export interface LoadingState {
  bootstrap: boolean;
  auth: boolean;
  delegate: boolean;
}

export const initialLoadingState: LoadingState = {
  bootstrap: false,
  auth: false,
  delegate: false,
};
